import { FaLocationArrow, FaLongArrowAltLeft } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { IoSettingsOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";

/* Fix Leaflet marker icons */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl:
        "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl:
        "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function Location() {

    const [city, setCity] = useState("Detecting...");
    const [country, setCountry] = useState("");
    const [lat, setLat] = useState(null);
    const [lon, setLon] = useState(null);
    const [timezone, setTimezone] = useState("--");
    const [temp, setTemp] = useState("--°C");

    const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme") || "dark";
        setTheme(savedTheme);
    }, []);

    const pageBg = theme === "dark" ? "dashboard-bg" : "bg-light";
    const cardBg = theme === "dark" ? "backgroundd-bg text-light" : "bg-white text-dark";
    const btnSecondary = theme === "dark" ? "btn btn-dark text-light" : "btn btn-gradientss text-light";
    const btnMain = theme === "dark" ? "btn btn-gradient text-light" : "btn btn-gradientss text-light";
    const textColor = theme === "dark" ? "text-light" : "text-dark";
    const inputBox = theme === "dark" ? "bg-dark shadow-sm text-light p-2 rounded" : "bg-light shadow-sm p-2 rounded text-dark";

    useEffect(() => {

        if (!navigator.geolocation) return;

        navigator.geolocation.getCurrentPosition((position) => {

            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            setLat(latitude);
            setLon(longitude);

            fetch(
                `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`,
                {
                    headers: {
                        Accept: "application/json",
                        "User-Agent": "TravelHubApp/1.0",
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {

                    setCity(
                        data.address.city ||
                        data.address.town ||
                        data.address.state ||
                        "Unknown"
                    );

                    setCountry(data.address.country || "");

                });

            setTimezone(
                Intl.DateTimeFormat().resolvedOptions().timeZone
            );

            fetch(
                `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&units=metric&appid=a22e65307679a644eec29e94b2ed88e8`
            )
                .then((res) => res.json())
                .then((data) => {

                    if (data.main) {
                        setTemp(`${Math.round(data.main.temp)}°C`);
                    }

                });

        });

    }, []);

    return (
        <>
            <title>Find Your Location Anywhere | Live Location Tracker – TravelToolkit</title>
            <meta name="description" content="Get your exact live location instantly with TravelToolkit. Discover your city, country, and coordinates with real-time GPS tracking for safe and smart travel anywhere in the world." />
            <meta name="keywords" content="live location finder, current location app, my location now, gps location tracker, find my city country" />

            <meta property="og:title" content="Find Your Location Anywhere | Live Location Tracker – TravelToolkit" />
            <meta property="og:site_name" content="traveltoolkit" />
            <meta property="og:url" content="https://traveltoolkit.online/Location" />
            <meta property="og:description" content="Get your exact live location instantly with TravelToolkit. Discover your city, country, and coordinates with real-time GPS tracking for safe and smart travel anywhere in the world." />
            <meta property="og:image" content="earth.gif"></meta>

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@traveltoolkit" />
            <meta name="twitter:description" content="Get your exact live location instantly with TravelToolkit. Discover your city, country, and coordinates with real-time GPS tracking for safe and smart travel anywhere in the world." />
            <meta name="twitter:app:country" content="India" />

            <div className="container-fluid p-0">
                <div className="row g-0">
                    <Sidebar />
                    <div className={`col-md-9 col-lg-10 ${pageBg} min-vh-100 p-3 offset-lg-2 offset-md-2`}>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="d-flex align-items-center gap-2">
                                <Link to="/Dashboard">
                                    <button className={btnSecondary}>
                                        <FaLongArrowAltLeft />
                                    </button>
                                </Link>
                                <h1 className={`${textColor} mb-0 h4`}>My Location</h1>
                            </div>
                            <Link to="/Settings">
                                <button className="btn btn-gradientss text-light">
                                    <IoSettingsOutline />
                                </button>
                            </Link>
                        </div>
                        {typeof lat === "number" && typeof lon === "number" && (
                            <MapContainer center={[lat, lon]} zoom={13} style={{ height: "240px", borderRadius: "14px", marginBottom: "20px", }}>
                                <TileLayer attribution="&copy; OpenStreetMap contributors" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                <Marker position={[lat, lon]}>
                                    <Popup>
                                        {city}, {country}
                                    </Popup>
                                </Marker>
                            </MapContainer>
                        )}
                        <div className={`card ${cardBg} p-3`}>
                            <div className="d-flex align-items-center gap-2 mb-3">
                                <div className="icon-circle d-flex align-items-center justify-content-center text-light">
                                    <FaLocationDot />
                                </div>
                                <div>
                                    <h6 className="mb-0">{city}</h6>
                                    <small>{country}</small>
                                </div>
                            </div>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className={inputBox}>
                                        <small className={textColor}>Latitude</small>
                                        <h6>{lat !== null ? lat.toFixed(4) : "--"}</h6>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={inputBox}>
                                        <small>Longitude</small>
                                        <h6>{lon !== null ? lon.toFixed(4) : "--"}</h6>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={inputBox}>
                                        <small>Timezone</small>
                                        <h6>{timezone}</h6>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={inputBox}>
                                        <small>Weather</small>
                                        <h6>{temp}</h6>
                                    </div>
                                </div>
                            </div>
                            <button className={`btn ${btnMain} w-100 mt-4`} onClick={() => window.location.reload()}>
                                <FaLocationArrow /> Refresh Location
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}